import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import getContext from 'recompose/getContext';
import { compose } from 'redux';
import TopBackground from '../components/TopBackground';
import { getScreenStyles } from '../selectors/layout';
import { getTopBackgroundColour } from '../selectors/screen';
function mapStateToProps(state, _a) {
    var isCurrentScreen = _a.isCurrentScreen;
    return {
        backgroundColor: getTopBackgroundColour(state, isCurrentScreen),
        width: getScreenStyles(state, isCurrentScreen).imageWidth,
    };
}
export default compose(getContext({ isCurrentScreen: PropTypes.bool.isRequired }), connect(mapStateToProps))(TopBackground);
